import { MouseEvent } from 'react';
import { Align } from '@progress/kendo-react-popup';
import { Moment } from 'moment/moment';
import {
    GroupOperatorItem,
    LogicOperator,
    ValueLabel,
} from '@components-clean/core/study-data-filter/advanced-select/advanced-select.interface';
import {
    PartialDateTimeIgnore,
    PrimitiveValues,
} from '@components-clean/core/study-data-filter/study-data-filter.interfaces';

export interface GridCustomFilterProps {
    anchor?: HTMLElement | null;
    show: boolean;
    filterValue: GridFilter | GridSearch | string | boolean | null | ClientGridFilterValues;
    dataType: DataType;
    anchorAlign?: Align;
    popupAlign?: Align;
    onCancel: (e?: MouseEvent<HTMLButtonElement>, clearFilter?: boolean) => void;
    onSelect: (data: GridFilter | ClientGridFilter, e: MouseEvent<HTMLButtonElement>) => void;
    clientGrid?: boolean;
    lovData?: string[];
    lovFilterContains?: boolean;
    filterKey?: string;
    ragColumn?: boolean;
    multiValueTypeColumn?: boolean;
    singleValueRagColumn?: boolean;
    searchText: string | boolean | null;
    filterDisabled?: boolean;
    evaluationColumn?: boolean;
    hideAdvancedFilter?: boolean;
}

export type ClientGridFilter = {
    filterValues: ClientGridFilterValues;
    operator: (current: string, { value1, value2 }: { value1: string; value2: string }) => void;
    value1Operator?: FilterOperators;
    value2Operator?: FilterOperators;
};

export interface ClientGridFilterValues {
    value1: string | boolean | Date | Moment | null | undefined;
    value2: string | boolean | Date | Moment | null | undefined;
}

export type GridFilter = {
    logic: LogicOperator | null;
    filters: SelectValue[];
    multiValueType?: RAGFilterType;
    ragType?: RAGFilterChipValues;
};

export type GridSearch = {
    search: string;
    type: DataType;
    multiValueType?: boolean;
};

export type SelectValue = {
    operator: FilterOperators | null;
    multiValueType?: RAGFilterType;
    ragType?: RAGFilterChipValues;
} & (NumericValue | DateValue | BoolValue | TextValue);

export type NumericValue = {
    dataType: DataType.Int | DataType.Decimal;
    value: string | null;
};

export type DateValue = {
    dataType: DataType.Date | DataType.DateTime;
    subType?: PartialDateTimeIgnore;
    value: string | null;
};

export type BoolValue = {
    dataType: DataType.Bool;
    value: string | null;
};

export type TextValue = {
    dataType: DataType.String;
    value: string | null;
};

export type FilterOperatorItem = ValueLabel<FilterOperators>;

export type FilterFormValues = {
    operator1: FilterOperatorItem;
    value1: PrimitiveValues | ValueLabel<boolean | null> | ValueLabel<string | null>;
    operator2: FilterOperatorItem;
    value2: PrimitiveValues | ValueLabel<boolean | null> | ValueLabel<string | null>;
    groupOperator: GroupOperatorItem;
};

export enum FilterOperators {
    Equal,
    NotEqual,
    GreaterThan,
    GreaterThanEqualTo,
    LessThan,
    LessThanEqualTo,
    Contains,
    DoesNotContain,
    StartsWith,
    EndsWith,
    IsNull,
    IsNotNull,
    Search,
    Like,
    NotLike,
    Includes,
    DoesNotInclude,
}

// Make sure these match the BE DataType otherwise filters can get a bit odd
export enum DataType {
    String = 0,
    Decimal = 1,
    Date = 2,
    Int = 3,
    DateTime = 4,
    Bool = 5,
}

export enum RAGFilterChipValues {
    Value = 1,
    Color = 2,
}

export enum RAGFilterType {
    ComparisonDataset = 1,
    DatasetInFocus = 2,
    Direction = 3,
    Current = 4,
    Previous = 5,
}
